import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { emptyFn } from '../../utils/helper';
import { decideKeepDom } from '../../utils/keepDom';
import Spin from '../Loading/Spin';
import { consumeTheme } from '../../utils/theme';
import { ShowCloseContext } from '../../utils/show';
import { PreventScrollPenetrateContainer } from '../../utils/preventScrollPenetrate';
import { updateVisibleSnackbars } from './queue';
import Button from '../Button';
export var SNACKBAR_TRANSITION_DURATION = 200;
export function isActionArray(action) {
    return Array.isArray(action) && action.length > 0 && action[0].text;
}
var Snackbar = (function (_super) {
    __extends(Snackbar, _super);
    function Snackbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prevTouchScreenY = 0;
        _this.handleTouchStart = function (e) {
            var touch = _this.getValidTouch(e);
            if (!touch) {
                return;
            }
            _this.prevTouchScreenY = touch.screenY;
        };
        _this.handleTouchMove = function (e) {
            var touch = _this.getValidTouch(e);
            if (!touch) {
                return;
            }
            if (_this.prevTouchScreenY - touch.screenY > 8) {
                return _this.context();
            }
            _this.prevTouchScreenY = touch.screenY;
        };
        _this.handleClickAction = function () {
            _this.props.onClickAction();
            _this.handleClose();
        };
        _this.handleClickClose = function () {
            _this.props.onClickClose();
            _this.handleClose();
        };
        _this.handleClose = function () {
            _this.props.onClose();
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, message = _b.message, placement = _b.placement, visible = _b.visible, type = _b.type, zIndex = _b.zIndex, testId = _b.testId, closable = _b.closable;
            var classes = classNames(prefixCls, className, prefixCls + "-" + placement, prefixCls + "-" + type, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a[prefixCls + "-override-icon"] = _this.renderUserSetIcon(classNames),
                _a));
            var messageClasses = classNames(prefixCls + "-message");
            if (!decideKeepDom.call(_this, SNACKBAR_TRANSITION_DURATION, visible)) {
                return null;
            }
            return ReactDOM.createPortal(h(PreventScrollPenetrateContainer, { className: classes, style: __assign({ zIndex: zIndex }, style), onTouchStart: _this.handleTouchStart, onTouchMove: _this.handleTouchMove, "data-testid": testId },
                _this.renderIcon(classNames),
                h("span", { className: messageClasses }, children || message),
                _this.renderAction(classNames),
                closable &&
                    h("div", { className: classNames(prefixCls + "-close"), onClick: _this.handleClickClose })), document.body);
        };
        return _this;
    }
    Snackbar.prototype.componentDidMount = function () {
        updateVisibleSnackbars(this);
    };
    Snackbar.prototype.componentDidUpdate = function () {
        updateVisibleSnackbars(this);
    };
    Snackbar.prototype.getValidTouch = function (e) {
        var _a = this.props, autoClose = _a.autoClose, visible = _a.visible;
        if (!visible || !autoClose) {
            return null;
        }
        return e.touches.item(0);
    };
    Snackbar.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Snackbar.prototype.renderAction = function (classNames) {
        var _this = this;
        var _a = this.props, prefixCls = _a.prefixCls, action = _a.action;
        if (!action) {
            return null;
        }
        if (isActionArray(action)) {
            return (h("span", { className: classNames(prefixCls + "-actions") }, action.map(function (a, index) {
                return h(Button, { key: index, className: classNames(prefixCls + "-action"), onClick: function () {
                        var _a;
                        (_a = a.onClick) === null || _a === void 0 ? void 0 : _a.call(a);
                        _this.handleClose();
                    } }, a.text);
            })));
        }
        return (h(Button, { className: classNames(prefixCls + "-action"), onClick: this.handleClickAction }, action));
    };
    Snackbar.prototype.renderUserSetIcon = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, type = _a.type, icon = _a.icon;
        if (!icon) {
            return null;
        }
        if (React.isValidElement(icon)) {
            return h("div", { className: classNames(prefixCls + "-icon-container") }, icon);
        }
        if (typeof icon === 'object' && icon[type]) {
            return h("div", { className: classNames(prefixCls + "-icon-container") }, icon[type]);
        }
        return null;
    };
    Snackbar.prototype.renderIcon = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, spinType = _a.spinType, type = _a.type;
        var userSetIcon = this.renderUserSetIcon(classNames);
        if (userSetIcon) {
            return userSetIcon;
        }
        return type === 'loading' ?
            h(Spin, { type: spinType, className: classNames(prefixCls + "-loading-indicator"), circleClassName: classNames(prefixCls + "-loading-indicator-circle") }) : null;
    };
    Snackbar.contextType = ShowCloseContext;
    return Snackbar;
}(React.Component));
export default Snackbar;
Snackbar.defaultProps = {
    prefixCls: 'dui-m-snackbar',
    placement: 'top',
    onClickAction: emptyFn,
    type: 'info',
    spinType: 'primary',
    closable: false,
    onClose: emptyFn,
    onClickClose: emptyFn,
};
